import { PartyForCard, isServiceParty } from 'components/service/party/partyRedesignCard/partyType';
import { Typography } from 'bento';
import { findNoteWithNoteType } from 'utils/noteUtils';
import { guestListShowNotesSelector } from 'selectors/dashboardPreferenceSelectors';
import { logger } from '@tock/logging';
import { partyCardDescriptionCssDefs } from 'components/service/party/partyRedesignCard/partyCardCssDefs';
import { useIsCompactView } from 'hooks/useIsCompactView';
import { useSelector } from 'react-redux';
import React from 'react';

export const BareVisitNotes: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const isCompactView = useIsCompactView();

  if (isCompactView) {
    // For compact view, we need to structure the visit note as a span within a div.
    // The inner span carries the typography info.
    return (
      <div css={partyCardDescriptionCssDefs.compactVisitNotesOuter}>
        <Typography
          component="span"
          variant="body"
          color="subtle"
          css={partyCardDescriptionCssDefs.compactVisitNotesInner}
        >
          {children}
        </Typography>
      </div>
    );
  } else {
    return (
      <Typography variant="body" color="subtle" css={partyCardDescriptionCssDefs.visitNotes}>
        {children}
      </Typography>
    );
  }
};

interface Props {
  party: PartyForCard;
}

const PartyRedesignVisitNotes: React.FC<Props> = ({ party }) => {
  const showGuestListNotes = useSelector(guestListShowNotesSelector);

  if (!party) {
    logger.warn(
      'PartyRedesignVisitNotes called without a "Service.Party" or "dashboard.CalendarWaitlist"'
    );
    return null;
  }

  let visitNote: string | undefined;
  if (isServiceParty(party)) {
    const bookingNotes = party.purchase?.auditedBookingNote;

    visitNote = (bookingNotes && findNoteWithNoteType('GENERAL', bookingNotes)?.note) || undefined;
  } else {
    visitNote = party.note;
  }

  if (!showGuestListNotes || !visitNote) {
    return null;
  }

  return <BareVisitNotes>{visitNote}</BareVisitNotes>;
};

export default PartyRedesignVisitNotes;
